import React from 'react';
import classnames from 'classnames';
import { Tab, Tabs as ReactTabs, TabPanel, TabList } from 'react-tabs';

import s from './Tabs.module.scss';

interface IProps {
  title?: string;
  tabs: Array<{
    title: string;
    content: React.ReactNode;
  }>;
}

export const Tabs = ({ title, tabs }: IProps) => {
  const tabsRef = React.useRef<HTMLDivElement | null>(null);
  const [overflowing, setOverflowing] = React.useState(false);

  React.useEffect(() => {
    overflowCheck();
    window.addEventListener('resize', overflowCheck);

    return () => {
      window.removeEventListener('resize', overflowCheck);
    };
  }, []);

  const overflowCheck = () => {
    const tabsBox = tabsRef.current;
    setOverflowing(tabsBox.offsetWidth < tabsBox.scrollWidth);
  };

  return (
    <section className={classnames(s.tabs, { [s.overflowing]: overflowing })}>
      <div className={s.tabs__container}>
        {title && (
          <header className={s.tabs__header}>
            <h1 className={s.tabs__title}>{title}</h1>
          </header>
        )}
        <ReactTabs>
          <div className={s.tabs__overflow}>
            <div ref={tabsRef} className={s.tabs__box}>
              <TabList className={s.tabs__list}>
                {tabs.map(({ title }, i) => (
                  <Tab className={s.tabs__item} selectedClassName={s.active} key={i}>
                    {title}
                  </Tab>
                ))}
              </TabList>
            </div>
          </div>

          <div className={s.tabs__content}>
            {tabs.map(({ content }, i) => (
              <TabPanel key={i}>{content}</TabPanel>
            ))}
          </div>
        </ReactTabs>
      </div>
    </section>
  );
};
